/**
 * One domain, many cities: apnashahar.online/<city>/<business>.
 * The city is the first path segment, so the router mounts with basename="/<city>" and every
 * existing link inside the portal keeps working unchanged.
 */
// First path segments that are NOT a city and must never be rewritten under a remembered one.
// `bill` (P2-002): a shared bill link is `/bill/<token>` with no city segment. Without this, a
// customer who had ever visited /biswan got `/bill/x` rewritten to `/biswan/bill/x`, which no
// city route matches, and landed on the city home instead of the bill (staging, 25 Sep 2026).
export const PLATFORM_PATHS = ["cities", "bill"];

export function firstSegment(pathname = window.location.pathname) {
  return (pathname.split("/").filter(Boolean)[0] || "").toLowerCase();
}

/**
 * Works out which city this URL is for and rewrites the address bar when the city is implied
 * rather than written (a remembered choice, or a legacy `?tenant=` link).
 * Returns "" when no city can be determined — the platform city chooser is shown instead.
 */
export function resolveCityFromUrl(slugs, remembered) {
  const url = new URL(window.location.href);
  const segment = firstSegment(url.pathname);
  if (slugs.includes(segment)) return segment;
  if (PLATFORM_PATHS.includes(segment)) return "";

  const asked = (url.searchParams.get("tenant") || "").toLowerCase();
  const candidate = [asked, (remembered || "").toLowerCase()].find((s) => s && slugs.includes(s)) || "";
  if (!candidate) return "";

  url.searchParams.delete("tenant");
  const search = url.searchParams.toString();
  const tail = url.pathname === "/" ? "" : url.pathname;
  window.history.replaceState({}, "", `/${candidate}${tail}${search ? `?${search}` : ""}${url.hash}`);
  return candidate;
}
